import Pagination from "@material-ui/lab/Pagination";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {  useLocation, useNavigate, useSearchParams,  } from "react-router-dom";
import { compose } from "redux";
import { createHistoryPush } from "../../../helpers/functions";
import { getAllDivisions } from "../../../redux/сompanies/actions";
import { usePaginationStyles } from "../../pages/PromoCodes/styles";
import Spinner from "../../components/ui/Spinner/Spinner";

import "./DivisionList.scss";
import { getCompaniesCurrentPageSelector, getCompaniesPageCountSelector, getCompaniesSelector } from "../../../redux/сompanies/selectors";

const CompanyList = ({
  companies,
  page_count,
  getAllDivisions,
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const classes = usePaginationStyles();
  const [searchParams] = useSearchParams()
  const location = useLocation();
  const navigate = useNavigate()
  const page = searchParams.get("page")
  
  const refreshCompanies = () => {
    setLoading(true)
    getAllDivisions(page)
      .then(() => setLoading(false))
  }

  useEffect(refreshCompanies, [page])

  const handleChangePage = (_, newPage) => {
    createHistoryPush({
      location,
      navigate,
      page: newPage,
    })
  }

  const CompanyItem = ({ title, email }) => (
    <div className="item-container">
      <p className="company-title">{title}</p>
      {email && <p className="company-email">{email}</p>}
    </div>
  );

  return (
    <>
      <div className="page-title">
        <span className="title">{t("companies")}</span>
      </div>
      {loading && (
        <div className="absoluteCenter">
          <Spinner />
        </div>
      )}
      {!loading && (
        <div className="companiesListContainer">
          {companies && companies.map((company) => (
            <CompanyItem 
              title={company.title} 
              email={company.email}
              key={company.id} 
            />
          ))}
        </div>
      )}
      <div className={classes.root}>
        <Pagination
          classes={{ ul: classes.ul }}
          count={page_count}
          color="primary"
          page={+page}
          defaultPage={1}
          size="large"
          onChange={handleChangePage}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  companies: getCompaniesSelector(state),
  current_page: getCompaniesCurrentPageSelector(state),
  page_count: getCompaniesPageCountSelector(state),
});

export default connect(mapStateToProps, { getAllDivisions })(CompanyList)
